import { toast } from "react-toastify";
import { endpoints, oids } from "../../../../configs/Settings";
import { HTTPResponseStatus } from "../../../../utils/enum";

import { useAuth } from "../../../../utils/useAuth";
import { useAxios } from "../../../../utils/useAxios";
import { auxiliarData } from "../../AuxiliarData";
import { ITaskData } from "@/utils/interfaces";
import { PostTask } from "../../task/PostTask";

export async function PostServiceRequest(
  objData: any,
  encounter: any,
  contained: any
) {
  let url = `${endpoints.EHRPOSTER}/`;

  const data = auxiliarData.ServiceRequest(objData, encounter, contained);

  const headers = {
    Accept: "application/fhir+json",
    Authorization: await useAuth.getUserToken(),
    "Content-Type": "application/fhir+json",
  };

  const response = await useAxios
    .post(url, data, { headers, timeout: 20000 })
    .then((response) => {
      if (
        response.status !== HTTPResponseStatus.Created &&
        response.status !== HTTPResponseStatus.Success
      ) {
        throw new Error(`PostMedicationRequest: ${response.status}`);
      }

      if (encounter?.requester) {
        // Task só em solicitação nova; órfãos de edição (já têm serviceRequestId) não criam Task de novo
        const isFreshRequest = objData?.some(
          (el: any) => !el?.serviceRequestId
        );
        if (isFreshRequest) {
          const taskData: ITaskData = {
            status: "requested",
            intent: "order",
            priority: "routine",
            description: `O médico ${encounter.requester.display} solicitou ${
              objData?.length > 1 ? "os exames" : "o exame"
            } ${objData?.map((item: any) => item.name)?.join(", ")}`,

            owner: encounter?.requester?.reference,
            for: `Patient/${oids.cpf}-${encounter?.subject}`,
          };

          // Cria a tarefa utilizando o PostTask
          PostTask(taskData);
        }
      }
      return response.data;
    })
    .catch((error) => {
      console.error("PostServiceRequest ", error);
      // toast.error(`PostServiceRequest Error: ${error?.response?.status}`);
      throw new Error();
    });
  if (response) return response;
}
